var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQueryBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 358,
    height: 69,
    viewBox: "0 0 358 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.5H342.793L357.5 15.2071V68.5H15.2071L0.5 53.7929V0.5Z",
    stroke: "url(#paint0_linear_339_8102)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_339_8102",
    x1: 294,
    y1: 69,
    x2: -0.00000384308,
    y2: 0.0000163748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12FDA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7730F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueryBorder);
export default __webpack_public_path__ + "static/media/queryBorder.eb03be0150430eda4ff1f8baea99e809.svg";
export { ForwardRef as ReactComponent };